import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type Authenticated = {
  label: DC_Repositories_Base_Enumerations_Label;
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  customerId: number;
};
/**
 * Signals after an user explictly successfully logged in (by using the login form). So no background re-authenticating.
 *
 * @returns void
 */
export function authenticated(
  { label, businessUnit, customerId }: Authenticated,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'POST',
      path: `/dxpweb/${businessUnit}/${label}/customers/${customerId}/signals/authenticated`,
    },
    requestConfig,
  );
}
